export const SET_POPUP = 'SET_POPUP'
export const CLOSE_POPUP = 'CLOSE_POPUP'
